import Icon from "@lib/common/components/Icon/Icon";
import { Button, Tooltip } from "@mantine/core";

/**
 * Trigger button shown next to the attach-document button in the chat
 * composer. Clicking dispatches the parent's `onClick` (the chat
 * controller's `enterResearchMode` action lands in Task 17).
 *
 * Styling intentionally mirrors the paperclip attach button in
 * `lib/experiment/agent/ExperimentDesignChatBox/ChatBox.tsx` so the two
 * sit visually together as a single toolbar pair.
 */
export function ExperimentResearchButton({ onClick }: { onClick: () => void }) {
  return (
    <Tooltip label="Switch to deep search mode">
      <Button color="gray" variant="subtle" size="sm" miw="unset" px="xs" onClick={onClick}>
        <Icon name="magnifying-glass" />
      </Button>
    </Tooltip>
  );
}
